import api from '@mint-lib/api';
import { AnyAction } from 'redux';

export const CALL_API = 'Call_API';

export type APIMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS';
export type ActionTypes = string[];
export interface MiddlewareActionData {
  endpoint: string;
  config: {
    method: APIMethod;
    data?: {
      [key: string]: any;
    };
    headers?: {
      [key: string]: any;
    };
  };
  types: ActionTypes;
  [key: string]: any;
}

// TODO:
const middleware =
  () =>
  (next: any) =>
  (action: AnyAction): Promise<any> => {
    if (!action[CALL_API]) {
      return next(action);
    }

    const { endpoint, types, config, ...params }: MiddlewareActionData =
      action[CALL_API];
    const [requestType, successType, errorType] = types;

    next({
      config,
      type: requestType,
      ...params,
    });

    return api
      .request({
        url: endpoint,
        ...config,
      })
      .then((response) => {
        if (response && typeof response.data === 'string') {
          next({
            headers: response.headers,
            config,
            type: successType,
            ...params,
          });
          return response.data;
        }

        next({
          data: response.data,
          headers: response.headers,
          config,
          type: successType,
          ...params,
        });
        return response.data;
      })
      .catch((error) => {
        if (!error.response) {
          throw error;
        }

        next({
          errorData: error.response.data,
          type: errorType,
          config,
          ...params,
          error,
        });

        throw error;
      });
  };

export default middleware;
